import { createRouter, createWebHistory } from 'vue-router'
import { applyMiddleware } from './middleware'
import buildMeta from './utils/buildMeta'

import accountRoutes from './routeGroups/account'
import planRoutes from './routeGroups/plans'
import authRoutes from './routeGroups/auth'
import dashboardRoutes from './routeGroups/dashboard'
import scanRoutes from './routeGroups/scan'
import devRoutes from './routeGroups/devRoutes'
import trackerRoutes from './routeGroups/jobTracker'
import widgetRoutes from './routeGroups/widget'
import historyRoutes from './routeGroups/history'
import domainRoutes from './routeGroups/domain'
import powerEditRoutes from './routeGroups/powerEdit'
import jobFeedRoutes from './routeGroups/jobFeed'
import resumeBuilderRoutes from './routeGroups/resumeBuilder'
import resumeManagerRoutes from './routeGroups/resumeManager'
import linkedinScanRoutes from './routeGroups/linkedinScan'
import matchReportRoutes from './routeGroups/matchReport'
import resumeScanRoutes from './routeGroups/resumeScan'
import resumeOptimizerRoutes from './routeGroups/resumeOptimizer'
import { env } from '@/lib/runtimeEnv'

const routes = [
  ...accountRoutes,
  ...planRoutes,
  ...authRoutes,
  ...dashboardRoutes,
  ...scanRoutes,
  ...trackerRoutes,
  ...widgetRoutes,
  ...historyRoutes,
  ...domainRoutes,
  ...powerEditRoutes,
  ...jobFeedRoutes,
  ...resumeBuilderRoutes,
  ...resumeManagerRoutes,
  ...linkedinScanRoutes,
  ...matchReportRoutes,
  ...resumeScanRoutes,
  ...resumeOptimizerRoutes,
  { name: 'root', path: '/', redirect: '/signup' },
  {
    name: 'notfound',
    path: '/:pathMatch(.*)*',
    component: () => import('@/pages/PageNotFound/PageNotFound.vue'),
    meta: buildMeta({
      authRequired: false,
      hideDistractions: true,
      liveChatEnabled: false,
      title: '404 - Page not found',
      description: 'Page not found',
      robots: 'noindex',
    }),
  },
]

if (env.VITE_RELEASE_STAGE !== 'production') {
  routes.push(...devRoutes)

  routes.push({
    name: 'power-edit',
    path: '/scan/:scanId/new-power-edit',
    component: () => import('@/pages/PowerEditNew/PowerEdit.vue'),
    meta: buildMeta({
      robots: 'noindex',
      hideDistractions: true,
      liveChatEnabled: false,
      title: 'Power Edit - Jobscan',
    }),
  })
}

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },
  routes,
})

applyMiddleware(router)

export default router
